import React from "react";
import { Redirect } from '@reach/router';
import { Helmet } from "react-helmet";
import slidesData from "../sources/slides-data";
import LayoutBody1 from "../components/layout-body-1";
import LayoutBody2 from "../components/layout-body-2";
import LayoutBody3 from "../components/layout-body-3";
import LayoutBody4 from "../components/layout-body-4";
import LayoutBody5 from "../components/layout-body-5";
import LayoutBody6 from "../components/layout-body-6";
import LayoutEssentials from "../components/layout-essentials";
import "../components/style.css";

const getSlideContent = (slideData) => {
  const { layout } = slideData;

  switch (layout) {
    case 1: {
      return <LayoutBody1 title={slideData.title} />;
    }
    case 2: {
      return (
        <LayoutBody2 
          header={slideData.header}
          header_span={slideData.header_span}
          image={slideData.image}
          paragraph={slideData.paragraph}
          paragraph_2={slideData.paragraph_2}
          paragraph_3={slideData.paragraph_3}
          title={slideData.title}
        />
      );
    }
    case 3: {
      return (
        <LayoutBody3 
          header={slideData.header}
          header_span={slideData.header_span}
          paragraph={slideData.paragraph}
          paragraph_2={slideData.paragraph_2}
          title={slideData.title}
          image={slideData.image}
        />
      );
    }
    case 4: {
      return (
        <LayoutBody4 
          footer={slideData.footer}
          header={slideData.header}
          header_span={slideData.header_span}
          image={slideData.image}
        />
      );
    }
    case 5: {
      return (
        <LayoutBody5>
          {slideData.children}
        </LayoutBody5>
      );
    }
    default: {
      return <Redirect noThrow to="/404" />;
    }
    case 6: {
      return (
        <LayoutBody6 
          header={slideData.header}
          header_span={slideData.header_span}
          paragraph={slideData.paragraph}
          paragraph_2={slideData.paragraph_2}
          paragraph_3={slideData.paragraph_3}
          paragraph_4={slideData.paragraph_4}
          title={slideData.title}
          image={slideData.image}
        />
      );
    }
  }  
};

const Slides = props => {
  const { pathname } = props.location;
  const slideIdentifier = pathname.substr(pathname.lastIndexOf('/') + 1);
  
  if (isNaN(slideIdentifier)) {
    return <Redirect noThrow to="/404" />;
  }

  const currSlideIndex = parseInt(slideIdentifier, 10);
  const currSlideData = slidesData[currSlideIndex];
  
  if (!currSlideData) {
    return <Redirect noThrow to="/404" />;
  }
  
  const slideLayout = `layout${currSlideData.layout} ${currSlideData.theme}`;
  const prevSlideIndex = currSlideIndex - 1;
  const prevSlide = prevSlideIndex < 0
    ? '/'
    : `/slides/${prevSlideIndex}`;
  const nextSlideIndex = currSlideIndex + 1;
  const nextSlide = `/slides/${nextSlideIndex}`;
  const showNextSlide = slidesData[nextSlideIndex] || null;
  
  return (
    <>
      <Helmet defer={false} title="N3TWORK Culture Book">
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,600;0,800;1,300&display=swap" rel="stylesheet" />
      </Helmet>
      <div className={`layout ${slideLayout}`}>
        {getSlideContent(currSlideData)}
        <LayoutEssentials
          prevSlide={prevSlide}
          nextSlide={nextSlide}
          showNext={showNextSlide}
        />
      </div>
    </>
  );
};

export default Slides;